<div
  class="container"
  [class.mb-0]="pictureSource === 'icon-academic'"
  [style]="'background: linear-gradient(143deg, ' + ((brandingColor$ | async) ?? defaultBrandingColor | hslColor) + ', ' + (greyColor | hslColor) + ')'">
  <span class="main-picture">
    <yat-icon *ngIf="pictureSource === 'icon-academic'; else pictureByPath" class="main-picture academic-svg" name="academic" [title]="title"></yat-icon>
    <ng-template #pictureByPath> <img *ngIf="pictureSource" [src]="pictureSource | safeUrl: 'image'" [alt]="title" /></ng-template>
  </span>
  <div class="header-container cursor-default">
    <div>
      <h1>{{ title || '&#xA0;' }}</h1>
    </div>
    <span class="vendor-name skeleton-item" *ngIf="subtitle">
      <yat-email-clip *ngIf="subtitle.includes('@'); else noEmail" [email]="subtitle" class="flex place-content-center"></yat-email-clip>
      <ng-template #noEmail>{{ subtitle }}</ng-template>
    </span>
    <ng-content></ng-content>
  </div>
</div>
